export default "__VITE_ASSET__Dp29lgdi__"